import { forwardRef } from "react";

export const ShareCard = forwardRef(({ amount }, ref) => (
  <div
    ref={ref}
    data-testid="share-card"
    className="relative w-full overflow-hidden rounded-3xl border border-black/5 shadow-[0_20px_50px_rgba(0,0,0,0.12)]"
    style={{ aspectRatio: "1 / 1", background: "linear-gradient(160deg,#FFFEF8 0%,#F3FDE9 55%,#E7FBFF 100%)" }}
  >
    <div
      className="absolute -right-16 -top-16 h-56 w-56 rounded-full blur-3xl"
      style={{ background: "rgba(204,255,0,0.55)" }}
    />
    <div
      className="absolute -bottom-20 -left-16 h-56 w-56 rounded-full blur-3xl"
      style={{ background: "rgba(34,211,238,0.4)" }}
    />

    <div className="relative flex h-full flex-col justify-between p-7">
      <div className="flex items-center gap-2">
        <span className="h-2.5 w-2.5 rounded-full bg-limeink" />
        <span className="font-display text-sm font-bold tracking-tight text-zinc-900">
          whatsmydataworth.com.au
        </span>
      </div>

      <div>
        <p className="text-sm font-semibold text-zinc-500">My personal data is worth</p>
        <div className="mt-1 flex items-baseline gap-1">
          <span className="font-display text-2xl font-bold text-aquaink">A$</span>
          <span className="text-gradient font-display text-6xl font-black leading-none tracking-tighter">
            {amount.toLocaleString()}
          </span>
          <span className="font-display text-xl font-bold text-zinc-400">/yr</span>
        </div>
      </div>

      <p className="font-display text-lg font-semibold leading-snug text-zinc-900">
        What's <span className="text-gold">yours</span> worth? 👀
      </p>
    </div>
  </div>
));

ShareCard.displayName = "ShareCard";
